// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

type Props = {
  label: Node,
  input: Node,
};

export function InputGroup({ label, input }: Props): Node {
  return (
    <div>
      <div>
        {label}
      </div>

      <InputHolder>
        {input}
      </InputHolder>
    </div>
  );
}

const InputHolder = styled.div`
  & > * {
    width: 100%;
  }
`;
